
export default function Error404() {
    return (
        <>
            error 404 page not found
        </>
    )
}